<template>
    <div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div id="callBackTodos" class="todo-category accordion-item">
                <div class="accordion-header-container">
                    <div class="accordion-header">
                        <button class="accordion-button collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#callBackTodo"
                                aria-expanded="false" aria-controls="callBackTodo">
                           <span class="round-icon bg-primary text-white me-3">
                                <i class="fa fa-phone"></i>
                           </span>
                           <span class="title">Nabellen</span>
                           <span class="ms-auto badge amount rounded-pill text-bg-primary">
                                {{ this.count }}
                           </span>
                        </button>
                    </div>
                </div>

                <div id="callBackTodo" class="accordion-collapse collapse" data-bs-parent="#todos">
                    <div class="accordion-body">
                        <div v-for="item in this.callBacks" class="todo">

                            <span v-if="item.is_overdue" class="warning success bg-light-red">
                                <i class="fa fa-exclamation text-danger icon-small"></i>
                            </span>

                            <div class="col-120">
                                <p class="mb-0">
                                    {{ item.name }}
                                </p>
                            </div>
                            <div class="col-140">
                                <p class="mb-0">
                                    <i class="fa fa-phone"></i>
                                    {{ item.phone }}
                                </p>
                            </div>
                            <div class="col-85">
                                <p class="mb-0 text-lightgrey">
                                    {{ item.date }}
                                </p>
                            </div>
                            <div class="col-120">
                                <p class="mb-0">
                                    {{ item.vtw_name }}
                                </p>
                            </div>
                            <div class="actions ms-auto">
                                <a :href="item.url" target="_blank">
                                    <i class="fa fa-external-link text-lightgrey"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

export default {
    name: 'todos-call-back',
    components: {},
    props: {},
    data() {
        return {
            callBacks: [{
                key: {
                    id: '',
                    name: '',
                    phone: '',
                    date: '',
                    vtw_name: '',
                    url: '',
                    is_overdue: '',
                }
            }],
            count: 0,
            loading: true,
        }
    },
    computed: {},
    watch: {},
    methods: {
        getCallBacks() {
            axios.get('api/todo-call-back')
                .then(response => {
                    this.callBacks = response.data.callBacks;
                    this.count = response.data.count;
                    this.loading = false;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },

    },
    mounted() {
        this.getCallBacks();
    },
    created() {},
}
</script>
